import {UnauthorizedError} from './errors'

const BASE_URL = '/api'

export async function apiFetch<T>(path: string, init?: RequestInit): Promise<T> {
    const headers: Record<string, string> = {
        'Content-Type': 'application/json',
        ...(init?.headers as Record<string, string>),
    }

    const res = await fetch(`${BASE_URL}${path}`, {
        ...init,
        headers,
    })

    if (res.status === 401) {
        throw new UnauthorizedError()
    }

    if (!res.ok) {
        const body = await res.json()
        throw new Error(body.detail || `API error: ${res.status}`)
    }

    if (res.status === 204) {
        return undefined as T
    }

    return res.json() as Promise<T>
}
